import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

import { ref, watch, nextTick, computed } from 'vue'
import { PAGE_SIZES, DEVICE_STATUS_ENUM, CODE_ENUM } from '@/common'
import moment from 'moment'


export default /*#__PURE__*/_defineComponent({
  __name: 'factory-testing-item',
  props: ['visible', 'data', 'title'],
  emits: ['update:visible'],
  setup(__props, { emit: __emit }) {

const props = __props
const $emit = __emit

const tableColumn: any = [
  {
    prop: 'label',
    label: '参数',
  },
  {
    prop: 'value',
    label: '实际值',
  },
  {
    prop: 'compare',
    label: '对比值',
  },
]

// get PaginationCurrentPage() {
//     const { pageNo, pageSize, Pagination } = this;
//     const endIndex = pageSize * pageNo;

//     return Pagination.slice(0, endIndex);
//   }
const tableData = computed(() => {
  const { curPage, pageSize } = pageParams.value
  const endIndex = curPage * pageSize
  const startIndex = (curPage - 1) * pageSize

  console.log(startIndex, endIndex, '====')
  return props.data.slice(startIndex, endIndex)
})

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})

const handleSizeChange = () => {
  pageParams.value.curPage = 1
}
const handleCurrentChange = () => {}

const handleClose = () => {
  $emit('update:visible', false)
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": props.visible,
    title: props.title,
    width: "1200",
    "before-close": handleClose
  }, {
    footer: _withCtx(() => []),
    default: _withCtx(() => [
      _createVNode(_component_el_table, {
        data: tableData.value,
        class: "ws_common_table ws_mt24"
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, { description: "暂无数据" })
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableColumn, (item, index) => {
            return _createVNode(_component_el_table_column, {
              key: index,
              prop: item.prop,
              label: item.label,
              formatter: item.formatter
            }, null, 8, ["prop", "label", "formatter"])
          }), 64)),
          _createVNode(_component_el_table_column, {
            label: "测试结果",
            prop: "testStatusValue",
            "show-overflow-tooltip": "",
            width: "300"
          }, {
            default: _withCtx((scoped) => [
              (scoped.row.testStatus)
                ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("成功")
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    type: "warning"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("失败")
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_el_pagination, {
        class: "ws_mt50",
        "current-page": pageParams.value.curPage,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageParams.value.curPage) = $event)),
        "page-size": pageParams.value.pageSize,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.pageSize) = $event)),
        "page-sizes": _unref(PAGE_SIZES),
        layout: "->, total, sizes, prev, pager, next, jumper ",
        total: props.data.length,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})